var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description accordion
         */
        calendarTeaser: {
            _obj: $('.calendar-teaser__date'),
            /**
             * @type {function}
             * @description initialize Accordion
             */
            init: function () {
                mzg.calendarTeaser.bindEvents();
            },
            bindEvents: function(){
                if(mzg.calendarTeaser._obj.length){
                    mzg.calendarTeaser._obj.click(function(){
                        var t = $(this);
                        t.parent('.calendar-teaser__preview-item')
                            .toggleClass('calendar-teaser__preview-item--active')
                            .find('.calendar-teaser__information')
                            .toggleClass('calendar-teaser__information--active');
                    });
                }
            }
        }
    }
);

$(mzg.calendarTeaser.init);
